import { SdgUnitsMode } from '@upright/common/model/output/scores/sdg-alignment/types';
import { getTitleStyle } from '@upright/ui/common/generic/content/texts/bou-title/title-style';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { BouSpacingLevel, fluidHorizontalPadding } from '@upright/ui/common/generic/layout/bou-spacing';
import { DesktopOnly, mobileOrNarrower, TabletOnly } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';
import { useSdgAlignmentsContext } from './context';
import { sdgAlignmentAreaWidth, sdgIconAndNameWidth } from './shared';

export const SdgHeader = () => {
  const context = useSdgAlignmentsContext();
  const unitsMode = context.viewOptions.unitsMode;

  return (
    <Root>
      <ContentWrap>
        <SdgNamePart>
          <DesktopOnly>UN Sustainable Development&nbsp;Goal</DesktopOnly>
          <TabletOnly>UN SDG</TabletOnly>
        </SdgNamePart>
        <AlignmentArea>
          <MisalignedPart>
            %&nbsp;of&nbsp;{unitsMode === SdgUnitsMode.SUMMARY_PERCENTAGE ? 'misalignment' : 'revenue misaligned'}
          </MisalignedPart>
          {/* OA: These non-breaking spaces in the end are to bring the text length to match
          with the "misaligned" side so that they break the line together. :D */}
          <AlignedPart>
            %&nbsp;of&nbsp;{unitsMode === SdgUnitsMode.SUMMARY_PERCENTAGE ? 'alignment' : 'revenue aligned'}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </AlignedPart>
        </AlignmentArea>
      </ContentWrap>
    </Root>
  );
};

const Root = styled.div`
  ${getTitleStyle({ size: 'h8' })}
  border-bottom: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
  padding-bottom: 1.5em;
  padding-top: 1.5em;
  letter-spacing: 0.1em;
  display: flex;
  align-items: flex-end;
  ${mobileOrNarrower(css`
    display: none;
  `)}
`;

const ContentWrap = styled.div`
  ${fluidHorizontalPadding(BouSpacingLevel.SMALL)}
  width: 100%;
  display: flex;
`;

const SdgNamePart = styled.div`
  ${sdgIconAndNameWidth}
`;

const AlignmentArea = styled.div`
  ${sdgAlignmentAreaWidth}
  display: flex;
  align-items: flex-end;
`;
const MisalignedPart = styled.div`
  width: 50%;
  text-align: end;
  margin-right: 4em;
`;
const AlignedPart = styled.div`
  width: 50%;
  margin-left: 4em;
`;
